
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "customer-portal-app",
  currentProjectVersion: "static-1.3556",
  depVersions: {
  "customer-portal-app": "static-1.3556",
  "apollo-dlb": "static-3.98",
  "avatar-components": "static-1.3027",
  "client-types": "static-1.524",
  "data-fetching-client": "static-1.10174",
  "emoji-mart": "static-3.10",
  "enviro": "static-4.529",
  "growth-payments-core": "static-1.26627",
  "head-dlb": "static-1.5344",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6129",
  "hs-test-utils": "static-1.8581",
  "hub-http": "static-1.6744",
  "hub-http-shared-msw-handlers": "static-1.11005",
  "hubspot-dlb": "static-2.1911",
  "hubspot-prosemirror": "static-1.19402",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.12027",
  "I18n": "static-7.1724",
  "immutable": "static-2.88",
  "jasmine-runner": "static-1.6997",
  "payment-link-components": "static-1.24586",
  "portals-platform-bend-plugin": "static-1.30",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7758",
  "quartz-core": "static-1.6977",
  "quartz-i18n": "static-1.1433",
  "react": "static-7.206",
  "react-colorpicker": "static-2.10748",
  "react-dlb": "static-1.97",
  "react-utils": "static-2.5718",
  "reselect": "static-3.20",
  "rich-text-lib": "static-1.20646",
  "transmute": "static-2.97",
  "ui-addon-upgrades": "static-9.18610",
  "ui-components-test-utils": "static-1.6164",
  "UIComponents": "static-3.8973",
  "video-player-core": "static-1.24",
  "foundations-assets": "static-1.5428",
  "foundations-components": "static-1.8850",
  "foundations-theming": "static-1.5040",
  "foundations-theming-specialty": "static-1.2756",
  "framer-motion": "static-1.87",
  "metrics-js": "static-1.9990",
  "PortalIdParser": "static-2.459",
  "portals-platform-lib": "static-1.1777",
  "pulse": "static-1.1207",
  "quartz-config": "static-1.1536",
  "quartz-routing": "static-1.1188",
  "quick-fetch": "static-1.4267",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.17278",
  "rpc-client-utils": "static-1.5205",
  "sanitize-text": "static-1.8696",
  "styled-components": "static-2.100",
  "tanstack-table": "static-1.69",
  "ui-addon-draggable": "static-3.5291",
  "ui-addon-react-router-dom": "static-1.10067",
  "usage-tracker": "static-1.7881",
  "usage-tracker-anonymous": "static-1.6298",
  "usage-tracker-core": "static-1.7731",
  "video-components-external": "static-1.12551",
  "apollo-stack-hubspot": "static-3.94",
  "hs-promise-rejection-tracking": "static-1.6102",
  "raven": "static-3.6435",
  "raven-hubspot": "static-1.6742",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.4035",
  "quartz-webpack": "static-1.3982",
  "bend-plugin-quartz-routing": "static-1.836",
  "hub-http-janus": "static-1.920",
  "hubspotter-http": "static-1.5013",
  "icons": "static-2.716",
  "StyleGuideUI": "static-3.521",
  "trellis-components": "static-1.3279",
  "trellis-migration-context": "static-1.117",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.96",
  "customer-data-objects": "static-1.8253",
  "frontend-preferences-client": "static-1.8462",
  "hs-browser-apis": "static-1.18",
  "laboratory-lib": "static-3.7687",
  "onboarding-scopes": "static-1.6991",
  "seat-types-lib": "static-1.1173",
  "ui-addon-opt": "static-4.8973",
  "HeadJS": "static-2.837",
  "hs-test-utils-bend-plugin": "static-1.3692",
  "msw": "static-1.106",
  "msw-config": "static-1.43",
  "testing-library": "static-1.168",
  "hs-locale-management": "static-1.442",
  "ts-schema": "static-1.4433",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8506",
  "content-media-capture": "static-1.5887",
  "cssUtils": "static-1.1162",
  "customer-data-ui-utilities": "static-1.10372",
  "file-manager-components": "static-1.24935",
  "HubStyle": "static-2.12334",
  "knowledge-content-types": "static-1.8767",
  "PatternValidationJS": "static-1.3415",
  "react-input-autosize": "static-2.17",
  "ui-addon-emoji-picker": "static-1.10403",
  "ui-addon-i18n": "static-1.11686",
  "ui-business-units-lib": "static-1.9635",
  "ui-shepherd-react": "static-3.10826",
  "video-data-lib": "static-1.36209",
  "i18n-data": "static-1.238",
  "moment-timezone": "static-5.99",
  "jasmine": "static-4.4844",
  "commerce-tours-lib": "static-1.6951",
  "customer-data-properties": "static-1.53249",
  "getting-started-shared-tasks": "static-1.19660",
  "growth-onboarding-reliability": "static-1.5622",
  "onboarding-tours": "static-1.17483",
  "reference-resolvers-lite": "static-1.8652",
  "sales-checkout-service-client": "static-1.4061",
  "ui-addon-iframeable": "static-1.9619",
  "user-context": "static-1.5597",
  "bender-build-tools": "static-1.3648",
  "dispatcher": "static-1.151",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.619",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.714",
  "quartz-auth": "static-1.1433",
  "quartz-head": "static-1.1423",
  "quartz-test": "static-1.1433",
  "quartz-tracking": "static-1.1137",
  "ui-fonts": "static-1.1289",
  "usage-tracker-container": "static-1.7871",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9963",
  "data-token-picker": "static-1.17225",
  "FileManagerLib": "static-1.40575",
  "property-translator": "static-1.5915",
  "merchandise-lib": "static-1.291",
  "purchase-motions-components": "static-1.6722",
  "SharedI18nStrings": "static-1.191",
  "foundations-components-test-utils": "static-1.6333",
  "react-create-root-preference": "static-1.122",
  "react-select-plus": "static-1.121",
  "react-virtualized": "static-2.115",
  "ui-images": "static-2.1296",
  "bend-plugin-foundations-components": "static-1.5119",
  "floating-ui": "static-1.71",
  "react-aria": "static-1.80",
  "trellis-assets": "static-1.3260",
  "bend-plugin-foundations-theming": "static-1.3523",
  "foundations-theming-base": "static-1.4025",
  "stylex": "static-1.49",
  "interframe": "static-3.5284",
  "js-cookie": "static-1.18",
  "pdf-js": "static-2.49",
  "usage-tracker-multi": "static-1.6295",
  "batch-promise": "static-1.2089",
  "bend-plugin-pulse": "static-1.710",
  "chirp-fetch": "static-1.2439",
  "event-emitter": "static-1.1499",
  "fast-json-patch": "static-1.77",
  "immer": "static-1.107",
  "opentelemetry-fe-types": "static-1.339",
  "beacon-keepalive-queue": "static-1.241",
  "web-vitals": "static-1.22",
  "bend-plugin-chirp-manifest": "static-1.615",
  "autolinker": "static-3.11",
  "sanitize": "static-1.5007",
  "react-flip-move": "static-1.86",
  "apollo-link-hub-http": "static-2.5128",
  "content-media-composition-data-lib": "static-1.13691",
  "content-media-compositions": "static-2.17698",
  "idb-keyval": "static-1.58",
  "immerable": "static-1.4683",
  "magpie-lib": "static-1.5962",
  "magpie-types": "static-1.5422",
  "media-bridge-lib": "static-1.19731",
  "sassPrefix": "static-1.426",
  "base-ui": "static-1.32",
  "react-day-picker": "static-1.19",
  "tanstack-virtual": "static-1.46",
  "trellis-theming": "static-1.1582",
  "inbound-db-properties-service-client": "static-1.4190",
  "superstore": "static-1.5294",
  "feedback-loader": "static-1.30150",
  "ai-components-ui-library": "static-1.10129",
  "ui-addon-video-player": "static-1.9161",
  "ui-coaching-tips": "static-1.29642",
  "ContentUtils": "static-1.69619",
  "fix-webm-duration": "static-1.38",
  "notification-sounds": "static-1.4968",
  "react-dnd-compat": "static-1.5149",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.2388",
  "copilot-toolkit": "static-1.12266",
  "poll-commands": "static-1.4015",
  "atom": "static-1.5612",
  "navigation-messaging": "static-1.8649",
  "redux-thunk": "static-2.88",
  "reference-resolvers": "static-1.8725",
  "commerce-products-lib": "static-1.11094",
  "crm-message-bus": "static-1.44259",
  "growth-data-modal": "static-1.6218",
  "hubspot-apollo-client": "static-1.5415",
  "onboarding-tours-client": "static-1.5698",
  "calling-global-api": "static-1.66512",
  "calling-internal-common": "static-1.31862",
  "calling-lifecycle-internal": "static-1.67894",
  "calling-lifecycle-messages": "static-1.60186",
  "conditional-properties-service-client": "static-1.4150",
  "crm-index-visualization-core": "static-1.4851",
  "crm-links": "static-1.6866",
  "crm-pipelines-api-client-types": "static-1.4484",
  "customer-data-objects-ui-components": "static-1.13575",
  "customer-data-properties-shared-msw-handlers": "static-1.10332",
  "customer-data-property-utils": "static-1.8598",
  "data-agent-utils": "static-1.1063",
  "external-options-client-types": "static-1.4478",
  "formula-editor": "static-1.15085",
  "google-libphonenumber": "static-1.53",
  "hs-resources": "static-1.735",
  "inbound-db-meta-service-client": "static-1.3810",
  "inbounddb-objects-service-types": "static-1.4554",
  "meetings-icalendar-utils-lib": "static-1.1174",
  "multi-currency-client-types": "static-1.4049",
  "object-builder-ui-client": "static-1.50218",
  "pipeline-validation-client-types": "static-1.4322",
  "property-value-citations": "static-1.3863",
  "react-tinymce": "static-1.56374",
  "smart-data-capture-core": "static-1.613",
  "tiered-pricing": "static-1.2389",
  "tinymce-config": "static-2.55500",
  "tinymce-plugins": "static-1.58614",
  "tinymce-themes": "static-1.57470",
  "topics-actions-lib": "static-1.732",
  "trellis-ext-i18n": "static-1.1481",
  "trial-components-library": "static-1.14483",
  "ui-addon-form-validation": "static-1.11353",
  "zustand": "static-1.93",
  "growth-onboarding-confetti": "static-1.3595",
  "growth-onboarding-next-action-utils": "static-1.3098",
  "navigation-components": "static-1.19322",
  "nest": "static-1.777",
  "onboarding-tours-utils": "static-1.1550",
  "ui-shepherd-tracker": "static-1.8207",
  "ui-universal-auth": "static-1.9861",
  "getting-started-shared-tasks-store": "static-1.18778",
  "opentelemetry-web": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.11003",
  "usage-tracker-session-replay": "static-1.5567",
  "audio-components": "static-1.6653",
  "FileManagerCore": "static-1.40434",
  "FileManagerImages": "static-1.38086",
  "video-components": "static-1.14553",
  "foundations-components-legacy": "static-1.1875",
  "purchase-motions-api": "static-1.6725",
  "signup-constants": "static-1.20114",
  "signup-ui-url-generator": "static-2.8574",
  "stylex-utils": "static-1.191",
  "usage-tracker-public": "static-1.7692",
  "reactive-lib": "static-1.1261",
  "simple-logging-lib": "static-1.3586",
  "nudge-client-utils": "static-1.3511",
  "chatspot-core": "static-1.24274",
  "growth-onboarding-feedback-components": "static-1.7124",
  "cms-field-types": "static-1.5352",
  "content-icons-ui": "static-1.2523",
  "integrations-lib": "static-1.17561",
  "underscore": "static-1.8",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1366",
  "breeze-engine-core": "static-1.1666",
  "highlight.js": "static-1.93",
  "markdown-it": "static-1.6",
  "nav-meta": "static-1.30959",
  "commerce-permissions": "static-1.1322",
  "customer-data-tracking": "static-1.7410",
  "products-iframe-lib": "static-1.9058",
  "products-ui-components-shared-msw-handlers": "static-1.11387",
  "onboarding-data-sync-lib": "static-1.2923",
  "hubspot-apollo-cache": "static-1.874",
  "calling-error-reporting": "static-1.31869",
  "shared-worker-versioning": "static-1.11579",
  "calling-usage-tracker": "static-1.7080",
  "conversations-skeleton-state": "static-1.7652",
  "voice-sms-access-library": "static-1.2611",
  "crm-index-associations-lib": "static-1.6989",
  "redux-toolkit": "static-1.85",
  "sales-views-client-types": "static-1.4797",
  "location-customization-utils-lib": "static-1.10557",
  "data-agent-kit": "static-1.1050",
  "enrichment-settings-lib": "static-1.408",
  "fsm": "static-1.4300",
  "policy-lib": "static-1.7343",
  "bark-lib": "static-1.17073",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.109",
  "crm-properties-common-lib": "static-1.6436",
  "react-codemirror": "static-1.11181",
  "fdsr-migration-layer": "static-1.553",
  "framework-builder-read-service-client": "static-1.4374",
  "upgrade-components-lib": "static-1.797",
  "tinymce": "static-5.11",
  "hub-http-contrib": "static-1.3569",
  "tinymce-data": "static-1.41585",
  "ui-addon-sales-email": "static-1.5746",
  "layout-dnd-components": "static-1.13320",
  "layout-dnd-utils": "static-1.12295",
  "ui-brand-identity-lib": "static-1.17098",
  "NamespacedHubStyle": "static-2.9407",
  "embedded-academy-lib": "static-1.16198",
  "hubs-service-types": "static-1.1805",
  "salesImages": "static-1.797",
  "growth-onboarding-next-action-components": "static-1.3126",
  "user-context-client": "static-1.5046",
  "custom-vendor-connection-lib": "static-1.425",
  "unified-auth-core-lib": "static-1.1657",
  "amplitude-session-replay-browser": "static-1.80",
  "breeze-artifacts-sdk": "static-1.1212",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.68",
  "urlinator": "static-1.5056",
  "video-embed": "static-1.37043",
  "social-insights-client-types": "static-1.23044",
  "nudge-custom-function-registry": "static-1.3268",
  "nudge-renderer-utils": "static-1.3587",
  "whisper-core-api": "static-1.7737",
  "flux-actions": "static-1.384",
  "integrations-error-boundary-lib": "static-1.14976",
  "integrations-tracking-lib": "static-1.6167",
  "native-integrations-shared-strings": "static-1.8297",
  "redux-observable": "static-1.82",
  "ReduxMessenger": "static-2.10911",
  "rxjs": "static-5.10",
  "InboxConnectUtils": "static-4.15955",
  "meetings-connect-utils-lib": "static-1.8158",
  "calling-orchestration-schema": "static-1.37388",
  "crm-record-cards-service-types": "static-1.3895",
  "highcharts": "static-8.118",
  "trellis-story-utils": "static-1.5035",
  "storybook-react": "static-1.47",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16771",
  "browser-eslint": "static-2.57",
  "persist-promise": "static-1.4246",
  "ContentData": "static-1.69694",
  "layout-data-lib": "static-1.10620",
  "academy-common-lib": "static-1.15659",
  "outpost": "static-1.4665",
  "universal-page-editor-lib": "static-1.3559",
  "advanced-menus-core": "static-1.15911",
  "advanced-menus-lib": "static-1.12641",
  "ExportDialog": "static-6.10913",
  "ui-memberships-settings-lib": "static-1.35328",
  "academy-service-client": "static-1.4232",
  "croppie": "static-2.10",
  "final-form": "static-1.86",
  "SafeStorage": "static-1.4934",
  "trellis-ecosystem": "static-1.7940",
  "crm-record-cards-client": "static-1.228",
  "framework-data-schema-resolvers": "static-1.7432",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15910",
  "simple-menus-lib": "static-1.17427",
  "settings-ui-lib": "static-1.13071",
  "marketplace-ui-apps-core": "static-1.19688",
  "marketplace-ui-common": "static-1.21156",
  "framework-data-schema-quick-fetch": "static-1.7337",
  "developer-experience-shared-components": "static-1.11084",
  "immutable-less": "static-1.5187",
  "marketplace-ui-client-types": "static-1.18563",
  "ui-addon-integrations-directory-panel": "static-2.8488",
  "ui-extensibility-client-types": "static-1.4457",
  "ai-settings-ui-library": "static-1.8688",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1809",
  "apps-service-types": "static-1.4147",
  "oauth-service-types": "static-1.4675",
  "simple-data-table": "static-1.3940"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3556",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "avatar-components": "/avatar-components/static-1.3027",
  "client-types": "/client-types/static-1.524",
  "data-fetching-client": "/data-fetching-client/static-1.10174",
  "emoji-mart": "/emoji-mart/static-3.10",
  "enviro": "/enviro/static-4.529",
  "growth-payments-core": "/growth-payments-core/static-1.26627",
  "head-dlb": "/head-dlb/static-1.5344",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6129",
  "hs-test-utils": "/hs-test-utils/static-1.8581",
  "hub-http": "/hub-http/static-1.6744",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.11005",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19402",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.12027",
  "I18n": "/I18n/static-7.1724",
  "immutable": "/immutable/static-2.88",
  "jasmine-runner": "/jasmine-runner/static-1.6997",
  "payment-link-components": "/payment-link-components/static-1.24586",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.30",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7758",
  "quartz-core": "/quartz-core/static-1.6977",
  "quartz-i18n": "/quartz-i18n/static-1.1433",
  "react": "/react/static-7.206",
  "react-colorpicker": "/react-colorpicker/static-2.10748",
  "react-dlb": "/react-dlb/static-1.97",
  "react-utils": "/react-utils/static-2.5718",
  "reselect": "/reselect/static-3.20",
  "rich-text-lib": "/rich-text-lib/static-1.20646",
  "transmute": "/transmute/static-2.97",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18610",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6164",
  "UIComponents": "/UIComponents/static-3.8973",
  "video-player-core": "/video-player-core/static-1.24",
  "foundations-assets": "/foundations-assets/static-1.5428",
  "foundations-components": "/foundations-components/static-1.8850",
  "foundations-theming": "/foundations-theming/static-1.5040",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2756",
  "framer-motion": "/framer-motion/static-1.87",
  "metrics-js": "/metrics-js/static-1.9990",
  "PortalIdParser": "/PortalIdParser/static-2.459",
  "portals-platform-lib": "/portals-platform-lib/static-1.1777",
  "pulse": "/pulse/static-1.1207",
  "quartz-config": "/quartz-config/static-1.1536",
  "quartz-routing": "/quartz-routing/static-1.1188",
  "quick-fetch": "/quick-fetch/static-1.4267",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.17278",
  "rpc-client-utils": "/rpc-client-utils/static-1.5205",
  "sanitize-text": "/sanitize-text/static-1.8696",
  "styled-components": "/styled-components/static-2.100",
  "tanstack-table": "/tanstack-table/static-1.69",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5291",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10067",
  "usage-tracker": "/usage-tracker/static-1.7881",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6298",
  "usage-tracker-core": "/usage-tracker-core/static-1.7731",
  "video-components-external": "/video-components-external/static-1.12551",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6102",
  "raven": "/raven/static-3.6435",
  "raven-hubspot": "/raven-hubspot/static-1.6742",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.4035",
  "quartz-webpack": "/quartz-webpack/static-1.3982",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.836",
  "hub-http-janus": "/hub-http-janus/static-1.920",
  "hubspotter-http": "/hubspotter-http/static-1.5013",
  "icons": "/icons/static-2.716",
  "StyleGuideUI": "/StyleGuideUI/static-3.521",
  "trellis-components": "/trellis-components/static-1.3279",
  "trellis-migration-context": "/trellis-migration-context/static-1.117",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.96",
  "customer-data-objects": "/customer-data-objects/static-1.8253",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8462",
  "hs-browser-apis": "/hs-browser-apis/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7687",
  "onboarding-scopes": "/onboarding-scopes/static-1.6991",
  "seat-types-lib": "/seat-types-lib/static-1.1173",
  "ui-addon-opt": "/ui-addon-opt/static-4.8973",
  "HeadJS": "/HeadJS/static-2.837",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3692",
  "msw": "/msw/static-1.106",
  "msw-config": "/msw-config/static-1.43",
  "testing-library": "/testing-library/static-1.168",
  "hs-locale-management": "/hs-locale-management/static-1.442",
  "ts-schema": "/ts-schema/static-1.4433",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8506",
  "content-media-capture": "/content-media-capture/static-1.5887",
  "cssUtils": "/cssUtils/static-1.1162",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10372",
  "file-manager-components": "/file-manager-components/static-1.24935",
  "HubStyle": "/HubStyle/static-2.12334",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "PatternValidationJS": "/PatternValidationJS/static-1.3415",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10403",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11686",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9635",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10826",
  "video-data-lib": "/video-data-lib/static-1.36209",
  "i18n-data": "/i18n-data/static-1.238",
  "moment-timezone": "/moment-timezone/static-5.99",
  "jasmine": "/jasmine/static-4.4844",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6951",
  "customer-data-properties": "/customer-data-properties/static-1.53249",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19660",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5622",
  "onboarding-tours": "/onboarding-tours/static-1.17483",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8652",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4061",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9619",
  "user-context": "/user-context/static-1.5597",
  "bender-build-tools": "/bender-build-tools/static-1.3648",
  "dispatcher": "/dispatcher/static-1.151",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.619",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.714",
  "quartz-auth": "/quartz-auth/static-1.1433",
  "quartz-head": "/quartz-head/static-1.1423",
  "quartz-test": "/quartz-test/static-1.1433",
  "quartz-tracking": "/quartz-tracking/static-1.1137",
  "ui-fonts": "/ui-fonts/static-1.1289",
  "usage-tracker-container": "/usage-tracker-container/static-1.7871",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9963",
  "data-token-picker": "/data-token-picker/static-1.17225",
  "FileManagerLib": "/FileManagerLib/static-1.40575",
  "property-translator": "/property-translator/static-1.5915",
  "merchandise-lib": "/merchandise-lib/static-1.291",
  "purchase-motions-components": "/purchase-motions-components/static-1.6722",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.191",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6333",
  "react-create-root-preference": "/react-create-root-preference/static-1.122",
  "react-select-plus": "/react-select-plus/static-1.121",
  "react-virtualized": "/react-virtualized/static-2.115",
  "ui-images": "/ui-images/static-2.1296",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5119",
  "floating-ui": "/floating-ui/static-1.71",
  "react-aria": "/react-aria/static-1.80",
  "trellis-assets": "/trellis-assets/static-1.3260",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3523",
  "foundations-theming-base": "/foundations-theming-base/static-1.4025",
  "stylex": "/stylex/static-1.49",
  "interframe": "/interframe/static-3.5284",
  "js-cookie": "/js-cookie/static-1.18",
  "pdf-js": "/pdf-js/static-2.49",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6295",
  "batch-promise": "/batch-promise/static-1.2089",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.710",
  "chirp-fetch": "/chirp-fetch/static-1.2439",
  "event-emitter": "/event-emitter/static-1.1499",
  "fast-json-patch": "/fast-json-patch/static-1.77",
  "immer": "/immer/static-1.107",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.339",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.241",
  "web-vitals": "/web-vitals/static-1.22",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.615",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.5007",
  "react-flip-move": "/react-flip-move/static-1.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5128",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13691",
  "content-media-compositions": "/content-media-compositions/static-2.17698",
  "idb-keyval": "/idb-keyval/static-1.58",
  "immerable": "/immerable/static-1.4683",
  "magpie-lib": "/magpie-lib/static-1.5962",
  "magpie-types": "/magpie-types/static-1.5422",
  "media-bridge-lib": "/media-bridge-lib/static-1.19731",
  "sassPrefix": "/sassPrefix/static-1.426",
  "base-ui": "/base-ui/static-1.32",
  "react-day-picker": "/react-day-picker/static-1.19",
  "tanstack-virtual": "/tanstack-virtual/static-1.46",
  "trellis-theming": "/trellis-theming/static-1.1582",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4190",
  "superstore": "/superstore/static-1.5294",
  "feedback-loader": "/feedback-loader/static-1.30150",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10129",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9161",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29642",
  "ContentUtils": "/ContentUtils/static-1.69619",
  "fix-webm-duration": "/fix-webm-duration/static-1.38",
  "notification-sounds": "/notification-sounds/static-1.4968",
  "react-dnd-compat": "/react-dnd-compat/static-1.5149",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2388",
  "copilot-toolkit": "/copilot-toolkit/static-1.12266",
  "poll-commands": "/poll-commands/static-1.4015",
  "atom": "/atom/static-1.5612",
  "navigation-messaging": "/navigation-messaging/static-1.8649",
  "redux-thunk": "/redux-thunk/static-2.88",
  "reference-resolvers": "/reference-resolvers/static-1.8725",
  "commerce-products-lib": "/commerce-products-lib/static-1.11094",
  "crm-message-bus": "/crm-message-bus/static-1.44259",
  "growth-data-modal": "/growth-data-modal/static-1.6218",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5415",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5698",
  "calling-global-api": "/calling-global-api/static-1.66512",
  "calling-internal-common": "/calling-internal-common/static-1.31862",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67894",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.60186",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4150",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4851",
  "crm-links": "/crm-links/static-1.6866",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4484",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13575",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10332",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8598",
  "data-agent-utils": "/data-agent-utils/static-1.1063",
  "external-options-client-types": "/external-options-client-types/static-1.4478",
  "formula-editor": "/formula-editor/static-1.15085",
  "google-libphonenumber": "/google-libphonenumber/static-1.53",
  "hs-resources": "/hs-resources/static-1.735",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3810",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4554",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1174",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4049",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50218",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4322",
  "property-value-citations": "/property-value-citations/static-1.3863",
  "react-tinymce": "/react-tinymce/static-1.56374",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.613",
  "tiered-pricing": "/tiered-pricing/static-1.2389",
  "tinymce-config": "/tinymce-config/static-2.55500",
  "tinymce-plugins": "/tinymce-plugins/static-1.58614",
  "tinymce-themes": "/tinymce-themes/static-1.57470",
  "topics-actions-lib": "/topics-actions-lib/static-1.732",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1481",
  "trial-components-library": "/trial-components-library/static-1.14483",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11353",
  "zustand": "/zustand/static-1.93",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3595",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3098",
  "navigation-components": "/navigation-components/static-1.19322",
  "nest": "/nest/static-1.777",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1550",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8207",
  "ui-universal-auth": "/ui-universal-auth/static-1.9861",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18778",
  "opentelemetry-web": "/opentelemetry-web/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.11003",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5567",
  "audio-components": "/audio-components/static-1.6653",
  "FileManagerCore": "/FileManagerCore/static-1.40434",
  "FileManagerImages": "/FileManagerImages/static-1.38086",
  "video-components": "/video-components/static-1.14553",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1875",
  "purchase-motions-api": "/purchase-motions-api/static-1.6725",
  "signup-constants": "/signup-constants/static-1.20114",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8574",
  "stylex-utils": "/stylex-utils/static-1.191",
  "usage-tracker-public": "/usage-tracker-public/static-1.7692",
  "reactive-lib": "/reactive-lib/static-1.1261",
  "simple-logging-lib": "/simple-logging-lib/static-1.3586",
  "nudge-client-utils": "/nudge-client-utils/static-1.3511",
  "chatspot-core": "/chatspot-core/static-1.24274",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7124",
  "cms-field-types": "/cms-field-types/static-1.5352",
  "content-icons-ui": "/content-icons-ui/static-1.2523",
  "integrations-lib": "/integrations-lib/static-1.17561",
  "underscore": "/underscore/static-1.8",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1366",
  "breeze-engine-core": "/breeze-engine-core/static-1.1666",
  "highlight.js": "/highlight.js/static-1.93",
  "markdown-it": "/markdown-it/static-1.6",
  "nav-meta": "/nav-meta/static-1.30959",
  "commerce-permissions": "/commerce-permissions/static-1.1322",
  "customer-data-tracking": "/customer-data-tracking/static-1.7410",
  "products-iframe-lib": "/products-iframe-lib/static-1.9058",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11387",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2923",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.874",
  "calling-error-reporting": "/calling-error-reporting/static-1.31869",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11579",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7080",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7652",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2611",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6989",
  "redux-toolkit": "/redux-toolkit/static-1.85",
  "sales-views-client-types": "/sales-views-client-types/static-1.4797",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10557",
  "data-agent-kit": "/data-agent-kit/static-1.1050",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.408",
  "fsm": "/fsm/static-1.4300",
  "policy-lib": "/policy-lib/static-1.7343",
  "bark-lib": "/bark-lib/static-1.17073",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.109",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6436",
  "react-codemirror": "/react-codemirror/static-1.11181",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.553",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4374",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.797",
  "tinymce": "/tinymce/static-5.11",
  "hub-http-contrib": "/hub-http-contrib/static-1.3569",
  "tinymce-data": "/tinymce-data/static-1.41585",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5746",
  "layout-dnd-components": "/layout-dnd-components/static-1.13320",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12295",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17098",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9407",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16198",
  "hubs-service-types": "/hubs-service-types/static-1.1805",
  "salesImages": "/salesImages/static-1.797",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3126",
  "user-context-client": "/user-context-client/static-1.5046",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.425",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1657",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.80",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1212",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.68",
  "urlinator": "/urlinator/static-1.5056",
  "video-embed": "/video-embed/static-1.37043",
  "social-insights-client-types": "/social-insights-client-types/static-1.23044",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3268",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3587",
  "whisper-core-api": "/whisper-core-api/static-1.7737",
  "flux-actions": "/flux-actions/static-1.384",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14976",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6167",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8297",
  "redux-observable": "/redux-observable/static-1.82",
  "ReduxMessenger": "/ReduxMessenger/static-2.10911",
  "rxjs": "/rxjs/static-5.10",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15955",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8158",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37388",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3895",
  "highcharts": "/highcharts/static-8.118",
  "trellis-story-utils": "/trellis-story-utils/static-1.5035",
  "storybook-react": "/storybook-react/static-1.47",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16771",
  "browser-eslint": "/browser-eslint/static-2.57",
  "persist-promise": "/persist-promise/static-1.4246",
  "ContentData": "/ContentData/static-1.69694",
  "layout-data-lib": "/layout-data-lib/static-1.10620",
  "academy-common-lib": "/academy-common-lib/static-1.15659",
  "outpost": "/outpost/static-1.4665",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3559",
  "advanced-menus-core": "/advanced-menus-core/static-1.15911",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12641",
  "ExportDialog": "/ExportDialog/static-6.10913",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35328",
  "academy-service-client": "/academy-service-client/static-1.4232",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.86",
  "SafeStorage": "/SafeStorage/static-1.4934",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7940",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.228",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7432",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15910",
  "simple-menus-lib": "/simple-menus-lib/static-1.17427",
  "settings-ui-lib": "/settings-ui-lib/static-1.13071",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19688",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21156",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7337",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11084",
  "immutable-less": "/immutable-less/static-1.5187",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18563",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8488",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4457",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8688",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1809",
  "apps-service-types": "/apps-service-types/static-1.4147",
  "oauth-service-types": "/oauth-service-types/static-1.4675",
  "simple-data-table": "/simple-data-table/static-1.3940"
}
};
